import React, {ReactElement} from 'react';
import {isEmpty} from 'lodash';
import {Route} from 'react-router';
import {MessageDescriptor} from '@lingui/core';

import {Permission} from '../model/Permission';
import ProtectedElement from '../ui/Security/ProtectedElement';
import IUserOutput from '../model/IUser';

export type MenuGroupKey = 'monitoring' | 'incidents';

export interface IProtectedRouteProps {
    path: string,
    element: ReactElement,
    label?: ReactElement,
    auth?: Permission[],
    title?: string | MessageDescriptor,
    icon?: ReactElement,
    target?: string,
    menuGroup?: MenuGroupKey,
    menuLabel?: string | MessageDescriptor,
    // eslint-disable-next-line no-unused-vars
    condition?: (user: IUserOutput) => boolean,
    hidden?: boolean,
}

export function isGrantedAccess(userPermissions: Permission[], auth: Permission[]| undefined):boolean {
    if (!auth || auth.length === 0) {
        return true;
    }

    return userPermissions.some(userPermission => auth.includes(userPermission));
}

export function getProtectedRoute({
    path,
    element,
    auth,
}: IProtectedRouteProps) {
    const protectedElement = auth && !isEmpty(auth)
        ? <ProtectedElement auth={auth} element={element}/>
        : element;

    return <Route
        key={path}
        path={path}
        element={protectedElement}
    />;
}